import { useState } from "react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export function ClientsList({ clients, setClients, authApi, canEdit }) {
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ certificate_number: "", organization_name: "", standard: "", scope: "", issue_date: "", expiry_date: "", status: "Active", country: "" });

  const addClient = async (e) => {
    e.preventDefault();
    const res = await authApi().post("/certified-clients", form);
    setClients([res.data, ...clients]);
    setForm({ certificate_number: "", organization_name: "", standard: "", scope: "", issue_date: "", expiry_date: "", status: "Active", country: "" });
    setShowNew(false);
    toast.success("Client added.");
  };

  const deleteClient = async (id) => {
    await authApi().delete(`/certified-clients/${id}`);
    setClients(clients.filter((c) => c.id !== id));
  };

  return (
    <div>
      {canEdit && (
        <div className="flex justify-end mb-4">
          <button onClick={() => setShowNew(!showNew)} data-testid="add-client-button" className="inline-flex items-center gap-1 bg-[#13A8BD] text-white px-4 py-2 text-xs font-semibold uppercase tracking-wider hover:bg-[#0e8a9c]">
            <Plus size={14} /> Add Client
          </button>
        </div>
      )}
      {showNew && (
        <form onSubmit={addClient} className="bg-white border border-[#0B2545]/10 p-6 mb-4 grid grid-cols-2 md:grid-cols-4 gap-3">
          <Input placeholder="Certificate No." value={form.certificate_number} onChange={(e) => setForm({ ...form, certificate_number: e.target.value })} className="rounded-none h-9 text-xs" />
          <Input placeholder="Organization" value={form.organization_name} onChange={(e) => setForm({ ...form, organization_name: e.target.value })} className="rounded-none h-9 text-xs" />
          <Input placeholder="Standard (e.g., ISO/IEC 27001:2022)" value={form.standard} onChange={(e) => setForm({ ...form, standard: e.target.value })} className="rounded-none h-9 text-xs" />
          <Input placeholder="Scope" value={form.scope} onChange={(e) => setForm({ ...form, scope: e.target.value })} className="rounded-none h-9 text-xs" />
          <Input type="date" placeholder="Issue Date" value={form.issue_date} onChange={(e) => setForm({ ...form, issue_date: e.target.value })} className="rounded-none h-9 text-xs" />
          <Input type="date" placeholder="Expiry Date" value={form.expiry_date} onChange={(e) => setForm({ ...form, expiry_date: e.target.value })} className="rounded-none h-9 text-xs" />
          <Input placeholder="Country" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} className="rounded-none h-9 text-xs" />
          <button type="submit" className="bg-[#0B2545] text-white text-xs font-bold uppercase tracking-wider h-9">Save</button>
        </form>
      )}
      <div className="bg-white border border-[#0B2545]/10">
        {clients.map((c) => (
          <div key={c.id} className="p-4 border-b border-[#0B2545]/10 last:border-b-0 flex items-center justify-between hover:bg-[#F7F9FC]">
            <div>
              <p className="text-sm font-bold text-[#0B2545]">{c.organization_name}</p>
              <p className="text-[10px] text-slate-500">{c.certificate_number} — {c.standard} — {c.country}</p>
              <p className="text-[10px] text-slate-400">Valid: {c.issue_date} to {c.expiry_date}</p>
            </div>
            <div className="flex items-center gap-2">
              <span className={`text-[10px] font-bold px-2 py-0.5 ${c.status === 'Active' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-600'}`}>{c.status}</span>
              {canEdit && <button onClick={() => deleteClient(c.id)} className="text-slate-300 hover:text-red-500"><Trash2 size={12} /></button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
